import React from 'react';
import './HeroProductListing.scss';
import ProductSummary from '../ProductSummary/ProductSummary';

/**
 * Renders the hero product listing module
 * @param {object} product
 * @param {string} starsAssetUrl
 * @param {function} addToCart
 * @returns {JSX.Element}
 * @constructor
 */
const HeroProductListing = ({ product, starsAssetUrl, addToCart }) => (
  <div className="c-hero-product-listing background-color-white">
    <div className="c-hero-product-listing__inner">
      <div className="c-hero-product-listing__text">
        <ProductSummary
          isHeroProductListing={true}
          product={product}
          starsAssetUrl={starsAssetUrl}
          addToCart={addToCart}
        />
      </div>
      <div className="c-hero-product-listing__image-container">
        <img src={product.image.url} alt={product.image.alt} />
      </div>
    </div>
  </div>
);

export default HeroProductListing;
